const ja = {
  title: "メッセージセンター",
  filterTpye: "メッセージの種類",
  plzSelect: "選択してください",
  serviceType: "営業のお知らせ",
  releaseTime: "送信時間",
  messageTitle: "メッセージのタイトル",
  messageContent: "メッセージ内容",
  sendTime: "送信時間",
  operation: "操作",
  viewDetails: "詳細",
  allRead: "全部読んだ",
  messageDetails: "メッセージの詳細",
  confirm: "確認",
  close: "閉鎖"
};
export default ja;